import { RedirectAnalysisService } from "../presentation/services/RedirectAnalysisService";
import { RedirectV2Service } from "../presentation/services/RedirectV2Service";

angular.module("nucont").config([
    "NavigationServiceProvider",
    (NavigationServiceProvider) => {
        // <----------------- EMPRESA ----------------- >

        NavigationServiceProvider.setItem({
            title: "Cadastro",
            uisref: "nucont.accounting.edit-company",
            cancelredirect: ["nucont.accounting.edit-company"],
            uisrefparams: ["accountingId", "id"],
            activeStates: ["nucont.accounting.edit-company"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-store-02",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 0
        });

        NavigationServiceProvider.setItem({
            title: "Dados",
            uisref: "nucont.accounting.company.dataRedirect",
            cancelredirect: [],
            uisrefparams: ["accountingId", "id", "source"],
            activeStates: [
                "nucont.accounting.company.dataManagement",
                "nucont.accounting.company.department.accounting.import",
                "nucont.accounting.company.department.tax.import",
                "nucont.accounting.company.department.personnel.import",
                "nucont.accounting.company.department.financial.import",
                "nucont.accounting.company.department.tax.edit",
                "nucont.accounting.company.department.personnel.edit",
                "nucont.accounting.company.department.financial.edit",
                "nucont.accounting.company.department.financial.scenarios",

                "nucont.accounting.company.department.accounting.scenarios"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-settings-01",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 0
        });

        NavigationServiceProvider.setItem({
            title: "Parametrização",
            uisref: "nucont.accounting.company.parameterizationOnDemand",
            cancelredirect: [],
            uisrefparams: ["source"],
            activeStates: [
                "nucont.accounting.company.parameterizationOnDemand"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-edit-02",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 0,
            accountingPlan: {
                module: { name: "ImportData", source: "accounting" }
            }
        });

        NavigationServiceProvider.setItem({
            title: "Contabilidades",
            uisref: "nucont.accountings.customers",
            activeStates: [
                "nucont.accountings.customers",
                "nucont.accountings.trial"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-store-02",
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.accountings.cards",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.plans",
                "nucont.publicvariablesIndicatorsChart.*",
                // Dentro de uma contabilidade o item sumia, e o interno ficava sem caminho de
                // volta pela navegação -- só apagando a URL na barra de endereços.
                //
                // A lista abaixo é a MESMA da "Página Inicial", de propósito: o item tem de
                // aparecer exatamente onde aparece a casa da contabilidade. Um curinga
                // `nucont.accounting.*` seria mais curto, mas arrastaria junto
                // `nucont.accounting.company.*` e `nucont.accounting.group.*` -- dentro da
                // empresa e do grupo o item não existe.
                "nucont.accounting",
                "nucont.accounting.journey",
                "nucont.accounting.journey.*",
                "nucont.accounting.overview.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.accounting.integration.*",
                "nucont.accounting.integrations",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*"
            ],
            // Só quem é da Nucont: o item leva para a lista de todas as contabilidades.
            flag: ["Super", "Sucesso", "NuHacker", "ChampionsLeads", "Heads"],
            position: 1
        });

        NavigationServiceProvider.setItem({
            title: "Administrativo",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.plans",
                "nucont.accountings.trial",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.publicvariablesIndicatorsChart.*"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            position: 1
        });

        NavigationServiceProvider.setItem({
            title: "Análises",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.company.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.edit-company",
                "nucont.accounting.groups.assign"
            ],
            group: true,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ],
            position: 1
        });

        NavigationServiceProvider.setItem({
            title: "Navegação",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.accountings.cards",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.plans",
                "nucont.publicvariablesIndicatorsChart.*"
            ],
            group: true,
            flag: ["Super", "Sucesso", "NuHacker", "ChampionsLeads", "Heads"],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 1.5
        });

        NavigationServiceProvider.setItem({
            title: "Gestão de Planos",
            uisref: "nucont.plans",
            activeStates: ["nucont.plans"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-settings-01",
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.accountings.cards",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.plans",
                "nucont.publicvariablesIndicatorsChart.*"
            ],
            flag: ["Super", "ChampionsLeads"],
            position: 2
        });

        // NavigationServiceProvider.setItem({
        //     title: "Central Consultiva",
        //     customHref: ({ accountingId }) => {
        //         return new RedirectV2Service().getUrl({
        //             accountingId,
        //             next: "/carteira-consultiva"
        //         });
        //     },
        //     cancelredirect: [
        //         "nucont.accounting.overview.portfolio.companies.resume"
        //     ],
        //     activeStates: [
        //         "nucont.accounting.journey",
        //         "nucont.accounting.groups.overview",
        //         "nucont.accounting.groups.monitoring.audit",
        //         "nucont.accounting.groups.monitoring.health",
        //         "nucont.accounting.groups.indicators",
        //         "nucont.accounting.overview.dashboard",
        //         "nucont.accounting.overview.dashboard.control-panel",
        //         "nucont.accounting.overview.dashboard.performance",
        //         "nucont.accounting.overview.dashboard.indicators",
        //         "nucont.accounting.overview.portfolio",
        //         "nucont.accounting.overview.portfolio.companies",
        //         "nucont.accounting.overview.portfolio.groups",
        //         "nucont.accounting.overview.monitoring",
        //         "nucont.accounting.overview.monitoring.audit",
        //         "nucont.accounting.overview.monitoring.health",
        //         "nucont.accounting.overview.portfolio.companies.resume",
        //         "nucont.accounting.overview.portfolio.companies.data",
        //         "nucont.accounting.overview.portfolio.companies.performance",
        //         "nucont.accounting.overview.portfolio.companies.register",
        //         "nucont.accounting.overview.portfolio.companies.contacts",
        //         "nucont.accounting.overview.portfolio.groups.resume",
        //         "nucont.accounting.overview.portfolio.groups.performance",
        //         "nucont.accounting.create-company",
        //         "nucont.accounting.edit-company",
        //         "nucont.accounting"
        //     ],
        //     icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-home-09",
        //     flag: [
        //         "Super",
        //         "Sucesso",
        //         "NuHacker",
        //         "ChampionsLeads",
        //         "Heads",
        //         "Contabilidade",
        //         "ContabilidadeTrial",
        //         "ContabilidadeTrialPro",
        //         "Contabil",
        //         "Comercial",
        //         "Financeiro",
        //         "Gestor",
        //         "Pessoal e Fiscal",
        //         "Pessoal",
        //         "Fiscal"
        //     ],
        //     available: [
        //         "nucont.accounting.nps.*",
        //         "nucont.accounting.reporting-center.*",
        //         "nucont.accounting.groups.overview",
        //         "nucont.accounting.groups.indicators",
        //         "nucont.accounting.groups.monitoring.*",
        //         "nucont.accounting.monitoring.*",
        //         "nucont.accounting.prospect",
        //         "nucont.accounting.prospect-dashboard",
        //         "nucont.accounting.contactsManagment.*",
        //         "nucont.accounting.create-company",
        //         "nucont.accounting.csc.*",
        //         "nucont.payments",
        //         "nucont.accounting.integration.*",
        //         "nucont.accounting.mySubscription",
        //         "nucont.accounting.customVariablesIndicatorsChart.*",
        //         "nucont.employee",
        //         "nucont.accounting.batch-import",
        //         "nucont.accounting.manager-users.*",
        //         "nucont.accounting.integrations",
        //         "nucont.accounting.overview.*",
        //         "nucont.accounting.journey.*",
        //         "nucont.accounting.journey",
        //         "nucont.accounting"
        //     ],
        //     uisrefparams: ["accountingId"],
        //     position: 2
        // });

        // ---------------------------------------------------------------
        // Menu da linha antiga. Estes itens vivem lado a lado com a Central
        // Consultiva no mesmo arquivo: o gate por plano decide qual dos dois
        // conjuntos a contabilidade enxerga. A CARTEIRA é a exceção — ela
        // aparece nos dois mundos, logo abaixo da Central.
        // ---------------------------------------------------------------

        NavigationServiceProvider.setItem({
            // A Carteira (a listagem de empresas do escritório) aparece com E sem
            // Agente Consultivo. A Central não a substitui: são duas leituras da
            // mesma carteira, e o contador usa as duas. Por isso não tem
            // `accountingPlan` nenhum — sem ele o `applyPlanContract` devolve
            // `contracted: true` sempre.
            //
            // "Carteira" e não "Página Inicial": ao lado da Central, "página
            // inicial" fica ambíguo — a casa de quem tem acesso é a Central. É
            // como a própria tela se chama (aba "Carteira") e como o
            // `HomeRedirectService` já a rotula.
            title: "Carteira",
            uisref: "nucont.accounting.overview.portfolio.companies.resume",
            cancelredirect: [
                "nucont.accounting.overview.portfolio.companies.resume"
            ],
            activeStates: [
                "nucont.accounting.journey",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.monitoring.audit",
                "nucont.accounting.groups.monitoring.health",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.overview.dashboard",
                "nucont.accounting.overview.dashboard.control-panel",
                "nucont.accounting.overview.dashboard.performance",
                "nucont.accounting.overview.dashboard.indicators",
                "nucont.accounting.overview.portfolio",
                "nucont.accounting.overview.portfolio.companies",
                "nucont.accounting.overview.portfolio.groups",
                "nucont.accounting.overview.monitoring",
                "nucont.accounting.overview.monitoring.audit",
                "nucont.accounting.overview.monitoring.health",
                "nucont.accounting.overview.portfolio.companies.resume",
                "nucont.accounting.overview.portfolio.companies.data",
                "nucont.accounting.overview.portfolio.companies.performance",
                "nucont.accounting.overview.portfolio.companies.register",
                "nucont.accounting.overview.portfolio.companies.contacts",
                "nucont.accounting.overview.portfolio.groups.resume",
                "nucont.accounting.overview.portfolio.groups.performance",
                // A criação de empresa parte da Carteira e é servida pelo menu dela (está no
                // `available` abaixo). O estado era reivindicado pela Central, que deixou de
                // reivindicar qualquer tela do v1 — sem ele, nenhum item do menu ficaria aceso
                // enquanto a pessoa cadastra a empresa.
                //
                // `edit-company` NÃO entra, embora a Central também o tivesse: lá o menu da
                // empresa é exibido junto, e o item "Cadastro" dele já reivindica esse estado.
                // Os dois acesos ao mesmo tempo é o defeito que esvaziar a Central corrigiu.
                "nucont.accounting.create-company",
                "nucont.accounting"
            ],
            // NÃO pode ser a casinha da Central: com os dois visíveis, e no menu
            // recolhido em que só o ícone aparece, dois ícones iguais empilhados
            // não dizem qual é qual. O v2 usa o equivalente (`Building06Icon`).
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-building-06",
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            // 2, não 1: a Central Consultiva também é `position: 1`, e no empate o
            // `orderBy` do template cai na ordem de inserção — a Carteira é
            // registrada antes e ficaria ACIMA da Central. O 2 está livre no menu
            // da contabilidade (3 é o divisor "Dados").
            position: 2
        });



        NavigationServiceProvider.setItem({
            title: "Central de Dash",
            uisref: "nucont.accounting.reporting-center.generateds",
            activeStates: ["nucont.accounting.reporting-center.generateds"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-share-08",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.integration.*",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 6,
            uisrefparams: ["accountingId"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });




        // Seções do menu da contabilidade. A ordem é dada pelo `position`; o mesmo
        // recorte e os mesmos nomes valem no v2, para as duas superfícies serem o
        // mesmo menu. Só o primeiro bloco muda entre quem tem e quem não tem o Agente.
        NavigationServiceProvider.setItem({
            title: "Dados",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 3
        });

        NavigationServiceProvider.setItem({
            title: "Entregas",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 5
        });

        NavigationServiceProvider.setItem({
            title: "Escritório",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 7
        });

        // Central Consultiva entra como item único, sempre abrindo a Visão Geral. As cinco
        // telas continuam alcançáveis pelas abas dentro da Central — o submenu duplicava a
        // mesma navegação em duas superfícies. Comentado, não apagado: volta quando decidirmos.
        NavigationServiceProvider.setItem({
            title: "Central Consultiva",
            // Só para quem tem o Agente Consultivo. Sem ele, o menu recebe de volta os itens da
            // linha antiga (Automações, Avaliações, Central de Dash), mais abaixo. A Carteira
            // não está nessa lista: ela aparece nos dois mundos, logo abaixo desta.
            accountingPlan: { requiredFeatures: ["AgenteConsultivo"] },
            // VAZIO de propósito. A Central é `customHref` para o v2 — nenhum state do v1 está
            // "dentro" dela. A lista que morava aqui era a mesma da Carteira (as telas de
            // overview/portfolio), o que era inofensivo enquanto as duas nunca coexistiam;
            // agora que coexistem, deixaria os DOIS itens acesos em qualquer tela de carteira.
            activeStates: [],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-home-09",
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 1,
            customHref: ({ accountingId }) => {
                return new RedirectV2Service().getUrl({
                    accountingId,
                    next: "/carteira-consultiva"
                });
            }
        });

        // Submenu da Central Consultiva — temporariamente fora do menu:
        // submenu: [
        // {
        // title: "Visão Geral",
        // customHref: ({ accountingId }) => {
        // return new RedirectV2Service().getUrl({
        // accountingId,
        // next: "/carteira-consultiva"
        // });
        // },
        // activeStates: [],
        // icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-building-06",
        // flag: [
        // "Super",
        // "Sucesso",
        // "NuHacker",
        // "ChampionsLeads",
        // "Heads",
        // "Contabilidade",
        // "ContabilidadeTrial",
        // "ContabilidadeTrialPro",
        // "Contabil",
        // "Comercial",
        // "Financeiro",
        // "Gestor",
        // "Pessoal e Fiscal",
        // "Pessoal",
        // "Fiscal"
        // ],
        // available: [
        // "nucont.accounting.nps.*",
        // "nucont.accounting.reporting-center.*",
        // "nucont.accounting.groups.overview",
        // "nucont.accounting.groups.indicators",
        // "nucont.accounting.groups.monitoring.*",
        // "nucont.accounting.monitoring.*",
        // "nucont.accounting.prospect",
        // "nucont.accounting.prospect-dashboard",
        // "nucont.accounting.contactsManagment.*",
        // "nucont.accounting.create-company",
        // "nucont.accounting.csc.*",
        // "nucont.payments",
        // "nucont.accounting.integration.*",
        // "nucont.accounting.mySubscription",
        // "nucont.accounting.customVariablesIndicatorsChart.*",
        // "nucont.employee",
        // "nucont.accounting.batch-import",
        // "nucont.accounting.manager-users.*",
        // "nucont.accounting.integrations",
        // "nucont.accounting.overview.*",
        // "nucont.accounting.journey.*",
        // "nucont.accounting.journey",
        // "nucont.accounting"
        // ],
        // position: 2
        // },
        // {
        // title: "Pendências Operacionais",
        // customHref: ({ accountingId }) => {
        // return new RedirectV2Service().getUrl({
        // accountingId,
        // next: "/pendencias"
        // });
        // },
        // activeStates: [],
        // icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-alert-02",
        // flag: [
        // "Super",
        // "Sucesso",
        // "NuHacker",
        // "ChampionsLeads",
        // "Heads",
        // "Contabilidade",
        // "ContabilidadeTrial",
        // "ContabilidadeTrialPro",
        // "Contabil",
        // "Comercial",
        // "Financeiro",
        // "Gestor",
        // "Pessoal e Fiscal",
        // "Pessoal",
        // "Fiscal"
        // ],
        // available: [
        // "nucont.accounting.nps.*",
        // "nucont.accounting.reporting-center.*",
        // "nucont.accounting.groups.overview",
        // "nucont.accounting.groups.indicators",
        // "nucont.accounting.groups.monitoring.*",
        // "nucont.accounting.monitoring.*",
        // "nucont.accounting.prospect",
        // "nucont.accounting.prospect-dashboard",
        // "nucont.accounting.contactsManagment.*",
        // "nucont.accounting.create-company",
        // "nucont.accounting.csc.*",
        // "nucont.payments",
        // "nucont.accounting.integration.*",
        // "nucont.accounting.mySubscription",
        // "nucont.accounting.customVariablesIndicatorsChart.*",
        // "nucont.employee",
        // "nucont.accounting.batch-import",
        // "nucont.accounting.manager-users.*",
        // "nucont.accounting.integrations",
        // "nucont.accounting.overview.*",
        // "nucont.accounting.journey.*",
        // "nucont.accounting.journey",
        // "nucont.accounting"
        // ],
        // position: 2
        // },
        // {
        // title: "Análise do Ciclo",
        // customHref: ({ accountingId }) => {
        // return new RedirectV2Service().getUrl({
        // accountingId,
        // next: "/analise-ciclo"
        // });
        // },
        // activeStates: [],
        // icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-analytics-01",
        // flag: [
        // "Super",
        // "Sucesso",
        // "NuHacker",
        // "ChampionsLeads",
        // "Heads",
        // "Contabilidade",
        // "ContabilidadeTrial",
        // "ContabilidadeTrialPro",
        // "Contabil",
        // "Comercial",
        // "Financeiro",
        // "Gestor",
        // "Pessoal e Fiscal",
        // "Pessoal",
        // "Fiscal"
        // ],
        // available: [
        // "nucont.accounting.nps.*",
        // "nucont.accounting.reporting-center.*",
        // "nucont.accounting.groups.overview",
        // "nucont.accounting.groups.indicators",
        // "nucont.accounting.groups.monitoring.*",
        // "nucont.accounting.monitoring.*",
        // "nucont.accounting.prospect",
        // "nucont.accounting.prospect-dashboard",
        // "nucont.accounting.contactsManagment.*",
        // "nucont.accounting.create-company",
        // "nucont.accounting.csc.*",
        // "nucont.payments",
        // "nucont.accounting.integration.*",
        // "nucont.accounting.mySubscription",
        // "nucont.accounting.customVariablesIndicatorsChart.*",
        // "nucont.employee",
        // "nucont.accounting.batch-import",
        // "nucont.accounting.manager-users.*",
        // "nucont.accounting.integrations",
        // "nucont.accounting.overview.*",
        // "nucont.accounting.journey.*",
        // "nucont.accounting.journey",
        // "nucont.accounting"
        // ],
        // position: 2
        // },
        // {
        // title: "Acompanhar Envios",
        // customHref: ({ accountingId }) => {
        // return new RedirectV2Service().getUrl({
        // accountingId,
        // next: "/entregas"
        // });
        // },
        // activeStates: [],
        // icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-sent",
        // flag: [
        // "Super",
        // "Sucesso",
        // "NuHacker",
        // "ChampionsLeads",
        // "Heads",
        // "Contabilidade",
        // "ContabilidadeTrial",
        // "ContabilidadeTrialPro",
        // "Contabil",
        // "Comercial",
        // "Financeiro",
        // "Gestor",
        // "Pessoal e Fiscal",
        // "Pessoal",
        // "Fiscal"
        // ],
        // available: [
        // "nucont.accounting.nps.*",
        // "nucont.accounting.reporting-center.*",
        // "nucont.accounting.groups.overview",
        // "nucont.accounting.groups.indicators",
        // "nucont.accounting.groups.monitoring.*",
        // "nucont.accounting.monitoring.*",
        // "nucont.accounting.prospect",
        // "nucont.accounting.prospect-dashboard",
        // "nucont.accounting.contactsManagment.*",
        // "nucont.accounting.create-company",
        // "nucont.accounting.csc.*",
        // "nucont.payments",
        // "nucont.accounting.integration.*",
        // "nucont.accounting.mySubscription",
        // "nucont.accounting.customVariablesIndicatorsChart.*",
        // "nucont.employee",
        // "nucont.accounting.batch-import",
        // "nucont.accounting.manager-users.*",
        // "nucont.accounting.integrations",
        // "nucont.accounting.overview.*",
        // "nucont.accounting.journey.*",
        // "nucont.accounting.journey",
        // "nucont.accounting"
        // ],
        // position: 2
        // },
        // {
        // title: "Explorar Carteira",
        // customHref: ({ accountingId }) => {
        // return new RedirectV2Service().getUrl({
        // accountingId,
        // next: "/explorar"
        // });
        // },
        // activeStates: [],
        // icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-safari",
        // flag: [
        // "Super",
        // "Sucesso",
        // "NuHacker",
        // "ChampionsLeads",
        // "Heads",
        // "Contabilidade",
        // "ContabilidadeTrial",
        // "ContabilidadeTrialPro",
        // "Contabil",
        // "Comercial",
        // "Financeiro",
        // "Gestor",
        // "Pessoal e Fiscal",
        // "Pessoal",
        // "Fiscal"
        // ],
        // available: [
        // "nucont.accounting.nps.*",
        // "nucont.accounting.reporting-center.*",
        // "nucont.accounting.groups.overview",
        // "nucont.accounting.groups.indicators",
        // "nucont.accounting.groups.monitoring.*",
        // "nucont.accounting.monitoring.*",
        // "nucont.accounting.prospect",
        // "nucont.accounting.prospect-dashboard",
        // "nucont.accounting.contactsManagment.*",
        // "nucont.accounting.create-company",
        // "nucont.accounting.csc.*",
        // "nucont.payments",
        // "nucont.accounting.integration.*",
        // "nucont.accounting.mySubscription",
        // "nucont.accounting.customVariablesIndicatorsChart.*",
        // "nucont.employee",
        // "nucont.accounting.batch-import",
        // "nucont.accounting.manager-users.*",
        // "nucont.accounting.integrations",
        // "nucont.accounting.overview.*",
        // "nucont.accounting.journey.*",
        // "nucont.accounting.journey",
        // "nucont.accounting"
        // ],
        // position: 2
        // }
        // ]

        NavigationServiceProvider.setItem({
            title: "Integrações",
            uisref: "nucont.accounting.integrations",
            activeStates: [
                "nucont.accounting.integrations",
                "nucont.accounting.integration",
                "nucont.accounting.integration.omie",
                "nucont.accounting.integration.contaazul",
                "nucont.accounting.integration.nibo",
                "nucont.accounting.integration.fortes",
                "nucont.accounting.integration.dominioideen",
                "nucont.accounting.integration.contabit",
                "nucont.accounting.integration.serpro"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-link-04",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 4,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "Contabil",
                "Financeiro",
                "Gestor",
                "Fiscal",
                "Pessoal",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        // --- análises ---
        // Existe outro grupo "Análises" mais acima, no escopo de EMPRESA/GRUPO. Não colidem: as
        // listas de `available` são disjuntas, e este só aparece nas telas de contabilidade.
        //
        // As telas moram no Analysis. O item é `customHref` para lá, pelo `/auth/live`, para o
        // cliente não cair na tela de login de um produto em que já está logado.
        //
        // Quem decide se aparecem é a liberação por contabilidade: `preferences.features` entra
        // como feature contratada no resolve da rota (`accounting.routes.js`), e o gate por plano
        // que já existe faz o resto — nenhum mecanismo novo de esconder item nasceu aqui.
        //
        // O divisor usa `features` (OU) e os itens usam `requiredFeatures` (E): a seção existe
        // enquanto qualquer análise estiver liberada, e cada item só com a sua. Sem isso o
        // escritório veria o título "Análises" sozinho, sem nada embaixo.
        NavigationServiceProvider.setItem({
            group: true,
            title: "Análises",
            accountingPlan: {
                features: ["AnaliseHibrido", "AnaliseRegimeTributario"]
            },
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 4,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
        });

        NavigationServiceProvider.setItem({
            title: "Modelo Híbrido",
            accountingPlan: { requiredFeatures: ["AnaliseHibrido"] },
            // VAZIO: nenhum state do v1 está "dentro" da análise, que vive em outro app.
            activeStates: [],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-arrow-data-transfer-horizontal",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 4,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            customHref: ({ accountingId }) => {
                return new RedirectAnalysisService().getUrl({
                    accountingId,
                    next: "/hibrido"
                });
            }
        });

        NavigationServiceProvider.setItem({
            title: "Regime Tributário",
            accountingPlan: {
                requiredFeatures: ["AnaliseRegimeTributario"]
            },
            activeStates: [],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-calculator-01",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 4,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            customHref: ({ accountingId }) => {
                return new RedirectAnalysisService().getUrl({
                    accountingId,
                    next: "/regime-tributario"
                });
            }
        });

        NavigationServiceProvider.setItem({
            title: "Contatos",
            uisref: "nucont.accounting.contactsManagment.companies",
            activeStates: [
                "nucont.accounting.contactsManagment",
                "nucont.accounting.contactsManagment.companies",
                "nucont.accounting.contactsManagment.others"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-contact-book",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 8,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Central de Mensagens",
            // Anda junto com a Central Consultiva: quem não tem o Agente não tem o chat.
            accountingPlan: { requiredFeatures: ["AgenteConsultivo"] },
            customHref: ({ accountingId }) => {
                return new RedirectV2Service().chatNucont({
                    accountingId
                });
            },
            newTab: true,
            activeStates: [],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-whatsapp",
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 6.5
        });

        NavigationServiceProvider.setItem({
            title: "Leitura Consultiva",
            // Dentro da empresa, este é o único item que depende do Agente Consultivo.
            // O resto do menu de empresa é igual nos dois mundos.
            accountingPlan: { requiredFeatures: ["AgenteConsultivo"] },
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-analytics-01",
            customHref: ({ accountingId, companyId }) => {
                return new RedirectV2Service().getUrl({
                    accountingId,
                    companyId,
                    next: companyId ? "/diagnostico" : "/carteira-consultiva"
                });
            },
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 2,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ]
        });

        NavigationServiceProvider.setItem({
            title: "Dashboards",
            uisref: "nucont.accounting.company.dashboards.view",
            cancelredirect: ["nucont.accounting.company.dashboards.view"],
            activeStates: [
                "nucont.accounting.company.dashboards.view",
                "nucont.accounting.company.customization.indicators",
                "nucont.accounting.company.customization.graphics",
                "nucont.accounting.company.customization.dashboards"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-chart-03",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 2,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ]
        });

        NavigationServiceProvider.setItem({
            title: "Gestão de Usuários",
            uisref: "nucont.admin-users",
            activeStates: ["nucont.admin-users", "nucont.admin-users.create"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-user-settings-01",
            available: [
                "nucont.accountings",
                "nucont.publicvariablesIndicatorsChart.*",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.plans"
            ],
            flag: ["Super"],
            position: 3
        });

        NavigationServiceProvider.setItem({
            title: "Demonstrações",
            uisref: "nucont.accounting.company.demonstrationsRedirect",
            cancelredirect: [
                "nucont.accounting.company.demonstrationsRedirect"
            ],
            activeStates: [
                "nucont.accounting.company.demonstrations.accounting.dre",
                "nucont.accounting.company.demonstrations.accounting.balancesheet",
                "nucont.accounting.company.demonstrations.accounting.balance",
                "nucont.accounting.company.demonstrations.fin.dre"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-table",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 4,
            uisrefparams: ["accountingId", "id", "scenarioId"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });


        NavigationServiceProvider.setItem({
            title: "Plano de Contas",
            uisref: "nucont.accounting.company.accountsPlan",
            cancelredirect: ["nucont.accounting.company.accountsPlan"],
            activeStates: ["nucont.accounting.company.accountsPlan"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-left-to-right-list-bullet",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source"],
            position: 5,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            contract: ["Standard", "Professional", "Expert"],
            accountingPlan: {
                module: { name: "AccountsPlan", source: "accounting" }
            }
        });

        // NavigationServiceProvider.setItem({
        //     title: "Análise Plus",
        //     activeStates: ["nucont.accountings"],
        //     available: [
        //         "nucont.accounting.company.*",
        //         "nucont.accounting.edit-company"
        //     ],
        //     group: true,
        //     flag: [
        //         "Contabilidade",
        //         "Contabil",
        //         "Fiscal",
        //         "Pessoal",
        //         "ContabilidadeTrialPro",
        //         "Super",
        //         "Sucesso",
        //         "NuHacker",
        //         "ChampionsLeads",
        //         "Heads",
        //         "Financeiro",
        //         "Gestor",
        //         "Pessoal e Fiscal",
        //         "Comercial"
        //     ],

        //     position: 6
        // });

        NavigationServiceProvider.setItem({
            group: true,
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 6,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ]
        });

        NavigationServiceProvider.setItem({
            title: "Objetivos",
            uisref: "nucont.accounting.company.monitoring.health",
            cancelredirect: ["nucont.accounting.company.monitoring.health"],
            activeStates: [
                "nucont.accounting.company.monitoring.health",
                "nucont.accounting.company.monitoring.health.config"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-target-01",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source"],
            position: 6,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Projeção",
            uisref: "nucont.accounting.company.projection",
            cancelredirect: [
                "nucont.accounting.company.projection",
                "nucont.accounting.company.projection.accounting",
                "nucont.accounting.company.projection.fin",
                "nucont.accounting.company.projection.tax",
                "nucont.accounting.company.projection.personnel"
            ],
            activeStates: [
                "nucont.accounting.company.projection.accounting",
                "nucont.accounting.company.projection.fin",
                "nucont.accounting.company.projection.tax",
                "nucont.accounting.company.projection.personnel"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-chart-up",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source", "accountPlanType"],
            position: 7,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            contract: ["Standard", "Professional", "Expert"],
            htmlId: "SidebarProjectionItem"
        });

        NavigationServiceProvider.setItem({
            title: "Orçamento",
            uisref: "nucont.accounting.company.budget",
            cancelredirect: [
                "nucont.accounting.company.budget",
                "nucont.accounting.company.budget.accounting",
                "nucont.accounting.company.budget.fin",
                "nucont.accounting.company.budget.tax",
                "nucont.accounting.company.budget.personnel"
            ],
            activeStates: [
                "nucont.accounting.company.budget.accounting",
                "nucont.accounting.company.budget.fin",
                "nucont.accounting.company.budget.tax",
                "nucont.accounting.company.budget.personnel"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-coins-01",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source", "accountPlanType"],
            position: 7,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            contract: ["Standard", "Professional", "Expert"],
            htmlId: "SidebarBudgetItem"
        });

        NavigationServiceProvider.setItem({
            title: "Personalização",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "Gestor",
                "Contabil"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 10
        });

        NavigationServiceProvider.setItem({
            title: "Entregas",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            group: true,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 8
        });

        NavigationServiceProvider.setItem({
            title: "Configurações",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.plans",
                "nucont.publicvariablesIndicatorsChart.*",
                "nucont.admin-users",
                "nucont.admin-users.create"
            ],
            group: true,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "Contabil",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Fiscal",
                "Pessoal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 9
        });

        NavigationServiceProvider.setItem({
            title: "Central de Dash",
            uisref: "nucont.accounting.company.reports",
            activeStates: ["nucont.accounting.company.reports"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-share-08",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 9,
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            accountingPlan: {
                module: { name: "Reports" }
            }
        });

        NavigationServiceProvider.setItem({
            title: "Customização",
            customHref: ({ accountingId }) => {
                return new RedirectV2Service().getUrl({
                    accountingId
                });
            },
            activeStates: [
                "nucont.accounting.customVariablesIndicatorsChart.variables",
                "nucont.accounting.customVariablesIndicatorsChart.indicators",
                "nucont.accounting.customVariablesIndicatorsChart.charts"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-settings-01",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 11,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "Gestor",
                "Contabil",
                "Financeiro"
            ],
            badgeContract: true,
            contract: ["Standard", "Expert", "Professional"],
            mediaQuery: ["hide-xs", "hide-sm"],
            accountingPlan: {
                module: { name: "GeneralCustomization" }
            }
        });

        NavigationServiceProvider.setItem({
            title: "Gestão de usuários",
            uisref: "nucont.accounting.manager-users.employee",
            activeStates: [
                "nucont.accounting.manager-users.employee",
                "nucont.accounting.manager-users.businessman"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-user-settings-01",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 9,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            accountingPlan: {
                features: ["UsersManagement"]
            }
        });

        NavigationServiceProvider.setItem({
            title: "Outros",
            activeStates: [
                "nucont.accounting.batch-import",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-more-horizontal",
            submenu: [
                {
                    title: "Avaliações",
                    uisref: "nucont.accounting.nps.view.feedbacksReports",
                    uisrefparams: ["accountingId"],
                    activeStates: [
                        "nucont.accounting.nps.view.overview",
                        "nucont.accounting.nps.view",
                        "nucont.accounting.nps.dashboard",
                        "nucont.accounting.nps.view.feedbacksReports"
                    ],
                    position: 4,
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Contabilidade",
                        "Beta"
                    ],
                    mediaQuery: ["hide-xs", "hide-sm"],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-star-half",
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.payments",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.employee",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    accountingPlan: {
                        features: ["NPS"]
                    }
                },
                {
                    title: "Objetivo",
                    uisref: "nucont.accounting.overview.monitoring.health",
                    cancelredirect: [
                        "nucont.accounting.overview.monitoring.health"
                    ],
                    activeStates: [
                        "nucont.accounting.overview.monitoring.health"
                    ],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-target-02",
                    activeStates: [
                        "nucont.accounting.overview.monitoring.health"
                    ],
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.payments",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.employee",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Heads",
                        "Contabilidade",
                        "ContabilidadeTrialPro",
                        "ContabilidadeTrial",
                        "Gestor",
                        "Contabil",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Pessoal e Fiscal",
                        "Comercial"
                    ],
                    accountingPlan: {
                        features: ["Objetivo"]
                    }
                },
                {
                    title: "Auditoria",
                    uisref: "nucont.accounting.overview.monitoring.audit",
                    cancelredirect: [
                        "nucont.accounting.overview.monitoring.audit"
                    ],
                    activeStates: [
                        "nucont.accounting.overview.monitoring.audit"
                    ],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-flag-02",
                    activeStates: [
                        "nucont.accounting.overview.monitoring.audit"
                    ],
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.payments",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.employee",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Heads",
                        "Contabilidade",
                        "ContabilidadeTrialPro",
                        "ContabilidadeTrial",
                        "Gestor",
                        "Contabil",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Pessoal e Fiscal",
                        "Comercial"
                    ],
                    accountingPlan: {
                        features: ["Auditoria"]
                    }
                },
                {
                    title: "Automações",
                    uisref: "nucont.accounting.reporting-center.automations",
                    activeStates: ["nucont.accounting.reporting-center.automations"],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-bot",
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    uisrefparams: ["accountingId", "id"],
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Heads",
                        "Contabilidade",
                        "ContabilidadeTrial",
                        "ContabilidadeTrialPro",
                        "Contabil",
                        "Comercial",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Gestor",
                        "Pessoal e Fiscal"
                    ],
                    mediaQuery: ["hide-xs", "hide-sm"],
                    position: 6
                },
                {
                    title: "Importação em lote",
                    uisref: "nucont.accounting.batch-import",
                    uisrefparams: ["accountingId"],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-upload-03",
                    activeStates: ["nucont.accounting.batch-import"],
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.payments",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.employee",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Heads",
                        "Contabilidade",
                        "ContabilidadeTrialPro",
                        "ContabilidadeTrial",
                        "Gestor",
                        "Contabil",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Pessoal e Fiscal",
                        "Comercial"
                    ],
                    accountingPlan: {
                        features: ["ImportacaoEmLote"]
                    }
                },
                {
                    title: "Leads",
                    uisref: "nucont.accounting.prospect",
                    uisrefparams: ["accountingId"],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-target-03",
                    activeStates: [
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard"
                    ],
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.payments",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.employee",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Heads",
                        "Contabilidade",
                        "ContabilidadeTrialPro",
                        "ContabilidadeTrial",
                        "Gestor",
                        "Contabil",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Pessoal e Fiscal",
                        "Comercial"
                    ],
                    accountingPlan: {
                        features: ["Leads"]
                    }
                }
            ],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 12,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "ContabilidadeTrial",
                "Gestor",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Pessoal e Fiscal",
                "Comercial"
            ]
        });

        // <----------------- GRUPO ----------------- >

        NavigationServiceProvider.setItem({
            title: "Cadastro",
            uisref: "nucont.accounting.groups.edit",
            activeStates: [
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-store-02",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 0
        });

        NavigationServiceProvider.setItem({
            title: "Leitura Consultiva",
            // Mesma regra do escopo de empresa: é o único item de grupo que some sem acesso.
            accountingPlan: { requiredFeatures: ["AgenteConsultivo"] },
            customHref: ({ accountingId, companyId }) => {
                return new RedirectV2Service().getUrl({
                    accountingId,
                    companyId,
                    next: "/diagnostico-grupo"
                });
            },
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-analytics-01",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 2,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ]
        });

        NavigationServiceProvider.setItem({
            title: "Dashboards",
            uisref: "nucont.accounting.group.dashboards.view",
            cancelredirect: ["nucont.accounting.group.dashboards.view"],
            activeStates: ["nucont.accounting.group.dashboards.view"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-chart-03",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 2,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });
        // A Auditoria do grupo já existia como rota (`group.monitoring.audit`), mas nunca teve
        // entrada no menu — só se chegava nela por link direto.
        NavigationServiceProvider.setItem({
            title: "Auditoria",
            uisref: "nucont.accounting.group.monitoring.audit",
            cancelredirect: ["nucont.accounting.group.monitoring.audit"],
            activeStates: [
                "nucont.accounting.group.monitoring.audit",
                "nucont.accounting.group.monitoring.audit.config",
                "nucont.accounting.group.monitoring.health"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-flag-02",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 3,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            contract: [
                "Standard",
                "Professional",
                "Expert",
                "ExpertFinanceiro"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });


        NavigationServiceProvider.setItem({
            title: "Auditoria",
            uisref: "nucont.accounting.company.monitoring.audit",
            cancelredirect: ["nucont.accounting.company.monitoring.audit"],
            activeStates: [
                "nucont.accounting.company.monitoring.audit",
                "nucont.accounting.company.monitoring.audit.config"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-flag-02",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source"],
            position: 3,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });
        NavigationServiceProvider.setItem({
            title: "Demonstrações",
            uisref: "nucont.accounting.group.demonstrationsRedirect",
            cancelredirect: ["nucont.accounting.group.demonstrationsRedirect"],
            activeStates: [
                "nucont.accounting.group.demonstrations.accounting.dre",
                "nucont.accounting.group.demonstrations.accounting.balancesheet",
                "nucont.accounting.group.demonstrations.accounting.balance",
                "nucont.accounting.group.demonstrations.fin.dre"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-table",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 4,
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            contract: [
                "Standard",
                "Professional",
                "Expert",
                "ExpertFinanceiro"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Plano de Contas",
            uisref: "nucont.accounting.group.accountsPlan",
            cancelredirect: ["nucont.accounting.group.accountsPlan"],
            activeStates: ["nucont.accounting.group.accountsPlan"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-left-to-right-list-bullet",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            uisrefparams: ["accountingId", "id", "source"],
            position: 5,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        // Cenários, Projeção e Orçamento andam juntos no grupo: os três são o mesmo objeto, o que
        // muda é o `type` do cenário (`standard` / `projection` / `budget`). Daí o divisor próprio.
        NavigationServiceProvider.setItem({
            title: "Planejamento",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            position: 6
        });

        NavigationServiceProvider.setItem({
            title: "Cenários",
            uisref: "nucont.accounting.group.scenarios.accounting",
            // As quatro fontes entram aqui. Faltando Fiscal e Pessoal -- que sao recentes --, o
            // menu nao marcava a pagina nessas duas abas e o item anterior seguia aceso.
            cancelredirect: [
                "nucont.accounting.group.scenarios",
                "nucont.accounting.group.scenarios.accounting",
                "nucont.accounting.group.scenarios.financial",
                "nucont.accounting.group.scenarios.tax",
                "nucont.accounting.group.scenarios.personnel"
            ],
            activeStates: [
                "nucont.accounting.group.scenarios.accounting",
                "nucont.accounting.group.scenarios.financial",
                "nucont.accounting.group.scenarios.tax",
                "nucont.accounting.group.scenarios.personnel"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-layers-01",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 7,
            // Sem `source`/`scenarioId`: o link aponta para a fonte Contabil, e levar os
            // parametros lembrados da tela anterior fazia a URL dizer `/contabil` com o cenario
            // (e a fonte) de outra aba -- a tela abria com cenario que nao existe na lista.
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            contract: [
                "Standard",
                "Professional",
                "Expert",
                "ExpertFinanceiro"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Projeção",
            uisref: "nucont.accounting.group.projection.accounting",
            cancelredirect: [
                "nucont.accounting.group.projection",
                "nucont.accounting.group.projection.accounting",
                "nucont.accounting.group.projection.fin",
                "nucont.accounting.group.projection.tax",
                "nucont.accounting.group.projection.personnel"
            ],
            activeStates: [
                "nucont.accounting.group.projection.accounting",
                "nucont.accounting.group.projection.fin",
                "nucont.accounting.group.projection.tax",
                "nucont.accounting.group.projection.personnel"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-chart-up",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 8,
            // Ver o comentario do item Cenarios.
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            contract: ["Standard", "Professional", "Expert"],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Orçamento",
            uisref: "nucont.accounting.group.budget.accounting",
            cancelredirect: [
                "nucont.accounting.group.budget",
                "nucont.accounting.group.budget.accounting",
                "nucont.accounting.group.budget.fin",
                "nucont.accounting.group.budget.tax",
                "nucont.accounting.group.budget.personnel"
            ],
            activeStates: [
                "nucont.accounting.group.budget.accounting",
                "nucont.accounting.group.budget.fin",
                "nucont.accounting.group.budget.tax",
                "nucont.accounting.group.budget.personnel"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-money-bag-02",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 9,
            // Ver o comentario do item Cenarios.
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            contract: ["Standard", "Professional", "Expert"],
            mediaQuery: ["hide-xs", "hide-sm"]
        });


        NavigationServiceProvider.setItem({
            title: "Entregas",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            group: true,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 10
        });

        // Central de Dash do grupo. Estava dentro de "Outros" da contabilidade, que é o
        // menu errado: é uma tela do escopo de grupo, e é lá que o contador a procura.
        NavigationServiceProvider.setItem({
            title: "Central de Dash",
            uisref: "nucont.accounting.group.reports",
            activeStates: ["nucont.accounting.group.reports"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-share-08",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            accountingPlan: {
                features: ["CentralDash"]
            },
            position: 11
        });
    }
]);
